module.exports = __webpack_public_path__ + "img/sup_cardsetting_bank4.632cdb3d.jpg";